import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class FeatureShowcase extends UcoastEl {
	static htmlSelector = 'feature-showcase'

	private toggles: HTMLButtonElement[] = []
	private medias: HTMLElement[] = []
	private panels: HTMLElement[] = []

	override connectedCallback() {
		super.connectedCallback()

		this.toggles = Array.from(q.ol<HTMLButtonElement>('[data-feature-toggle]', this) ?? [])
		this.medias = Array.from(q.ol<HTMLElement>('[data-feature-media]', this) ?? [])
		this.panels = Array.from(q.ol<HTMLElement>('[data-feature-panel]', this) ?? [])

		this.toggles.forEach((toggle) => {
			toggle.addEventListener('click', () => {
				const index = toggle.dataset.featureToggle
				if (index) this.activate(index)
			})
		})
	}

	private activate(index: string) {
		if (this.dataset.activeIndex === index) return
		this.dataset.activeIndex = index

		this.toggles.forEach((t) => {
			t.setAttribute('aria-pressed', String(t.dataset.featureToggle === index))
		})

		this.medias.forEach((m) => this.setItemActive(m, m.dataset.featureMedia === index))
		this.panels.forEach((p) => this.setItemActive(p, p.dataset.featurePanel === index))

		const activeMedia = this.medias.find((m) => m.dataset.featureMedia === index)
		const aspect = activeMedia?.dataset.aspect
		if (aspect) this.style.setProperty('--stage-aspect', aspect)
	}

	private setItemActive(el: HTMLElement, active: boolean) {
		el.dataset.active = String(active)
		el.setAttribute('aria-hidden', String(!active))
	}
}
